<template>
  <el-form ref="nvrForm" :model="nvrForm" :rules="nvrRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="nvrForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[nvrForm.status] }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="国标设备编号" prop="deviceNoNational">
          <el-row v-if="!isDetail()">
            <GB28181 ref="nationalNo" :areaList="areaList" v-model="nvrForm.deviceNoNational" />
            <el-input
              style="margin-top: 8px"
              class="select-search"
              v-model="nvrForm.deviceNoNational"
              placeholder="上方内容均选择后，自动生成编号"
              disabled
            ></el-input>
          </el-row>
          <span v-else>{{ nvrForm.deviceNoNational }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备序列号" prop="serialNum">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.serialNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.serialNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通道个数" prop="channelNum">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.channelNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.channelNum || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="硬盘个数" prop="hardDiskNum">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.hardDiskNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.hardDiskNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报警输入个数" prop="callInNum">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.callInNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.callInNum || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="报警输出个数" prop="callOutNum">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.callOutNum"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.callOutNum || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="主控版本" prop="masterVersion">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.masterVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.masterVersion || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="编码版本" prop="codeVersion">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.codeVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.codeVersion || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="Web版本" prop="webVersion">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.webVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.webVersion || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="Plugin版本" prop="pluginVersion">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.pluginVersion"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.pluginVersion || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="发布日期" prop="time">
          <el-date-picker
            v-if="!isDetail()"
            value-format="yyyy-MM-dd"
            v-model="nvrForm.time"
            type="date"
            placeholder="请选择日期"
          >
          </el-date-picker>
          <span v-else>{{ nvrForm.time || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备物理地址（mac）" prop="mac">
          <el-input
            v-if="!isDetail()"
            v-model="nvrForm.mac"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ nvrForm.mac || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { isEmpty, isEqual } from 'lodash';
import deviceApi from 'api/home/device-mangement';
import GB28181 from './GB28181Create';
import { getGbList } from '@/utils/getGbList';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  components: {
    GB28181
  },
  props: {
    value: {
      type: Object
    },
    deviceCategoryId: {
      default: ''
    },
    areaList: {
      default: () => []
    }
  },
  data() {
    return {
      administrativeAreasList: [],
      industryList: [],
      gbDeviceTypeList: [],
      networkAccessList: [],
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      interNoGetSelect: {
        administrativeAreas: [],
        industry: '',
        deviceType: '',
        networkAccess: []
      },
      history: {
        deviceNoNational: '',
        interNoGetSelect: {
          administrativeAreas: [],
          industry: '',
          deviceType: '',
          networkAccess: ''
        }
      },
      nvrForm: {}
    };
  },
  inject: ['isDetail'],
  created() {
    this.getGbList();
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.nvrForm = newVal;
      }
    },
    nvrForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    },
    interNoGetSelect: {
      deep: true,
      handler: function (newVal) {
        if (!isEqual(this.history.interNoGetSelect, newVal) && this.nationNoListTypeFlag) {
          this.getNationNo();
        } else {
          this.nvrForm.deviceNoNational = '';
        }
      }
    }
  },
  computed: {
    nationNoListTypeFlag() {
      const { administrativeAreas, industry, deviceType, networkAccess } = this.interNoGetSelect;
      const flag =
        !isEmpty(administrativeAreas) &&
        !isEmpty(industry) &&
        !isEmpty(deviceType) &&
        !isEmpty(networkAccess);
      return flag;
    },
    nvrRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }],
        deviceNoNational: [
          { required: !this.isDetail(), message: '请选择国际设备编号', trigger: 'blur' }
        ]
      };
    }
  },
  methods: {
    getNationNo() {
      if (!this.nationNoListTypeFlag) {
        return;
      }
      const { administrativeAreas, industry, deviceType, networkAccess } = this.interNoGetSelect;
      const data = {
        isChannel: false,
        networkCode: networkAccess,
        deviceTypeCode: deviceType,
        industryCode: industry,
        areaCode: administrativeAreas[administrativeAreas.length - 1]
      };
      deviceApi.getGbNo(data).then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.nvrForm.deviceNoNational = data;
      });
      // if(isEqual(this.history.interNoGetSelect, newVal)){
      //   // this.nvrForm.deviceNoNational  = this.history.deviceNoNational
      // }
      // getNationNum(this.interNoGetSelect).then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.nvrForm.deviceNoNational = res.data
      // });
    },
    getGbList() {
      getGbList(this);
    },
    getNationAgian() {
      this.$refs.nationalNo.getNationNo();
    },
    areaChange(val) {
      this.$refs.areaList.dropDownVisible = false;
    },
    getData() {
      let data = {
        deviceModel: this.nvrForm.deviceModel,
        factoryNo: this.nvrForm.factoryNo,
        status: this.nvrForm.status,
        deviceNoNational: this.nvrForm.deviceNoNational,
        deviceSerialNumber: this.nvrForm.serialNum,
        channelNumber: this.nvrForm.channelNum,
        diskNumber: this.nvrForm.hardDiskNum,
        alarmInputNumber: this.nvrForm.callInNum,
        alarmOutputNumber: this.nvrForm.callOutNum,
        icVersion: this.nvrForm.masterVersion,
        codeVersion: this.nvrForm.codeVersion,
        webVersion: this.nvrForm.webVersion,
        pluginVersion: this.nvrForm.pluginVersion,
        physicalAddress: this.nvrForm.mac,
        releaseDate: this.nvrForm.time || ''
      };
      return data;
    },
    setData(data) {
      const {
        deviceModel,
        factoryNo,
        status,
        deviceNoNational,
        deviceSerialNumber,
        channelNumber,
        diskNumber,
        alarmInputNumber,
        alarmOutputNumber,
        icVersion,
        codeVersion,
        webVersion,
        pluginVersion,
        physicalAddress,
        releaseDate
      } = data;
      this.nvrForm.deviceModel = deviceModel;
      this.nvrForm.factoryNo = factoryNo;
      this.nvrForm.status = status;
      this.nvrForm.deviceNoNational = deviceNoNational;
      this.nvrForm.serialNum = deviceSerialNumber;
      this.nvrForm.channelNum = channelNumber;
      this.nvrForm.hardDiskNum = diskNumber;
      this.nvrForm.callInNum = alarmInputNumber;
      this.nvrForm.callOutNum = alarmOutputNumber;
      this.nvrForm.masterVersion = icVersion;
      this.nvrForm.codeVersion = codeVersion;
      this.nvrForm.webVersion = webVersion;
      this.nvrForm.pluginVersion = pluginVersion;
      this.nvrForm.mac = physicalAddress;
      this.nvrForm.time = releaseDate;
    },
    reset() {
      this.$refs.nvrForm.resetFields();
      this.$refs.nationalNo && this.$refs.nationalNo.reset();
    },
    validate() {
      let type;
      this.$refs.nvrForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>

